import { z } from 'zod';

export const setSocialLibraryMinClipsV1RequestSchema = z.object({
  minClips: z.number(),
});

export type ISetSocialLibraryMinClipsV1Request = z.infer<
  typeof setSocialLibraryMinClipsV1RequestSchema
>;
